<script>
  //import regions from '@/data.js'
  import regions from '../../static/js/data.js'
  import regionstr from '../../static/js/datatr.js'

  export default {
    name: 'CountrySelect',
    props: {
      country: String,
      countryName: Boolean,
      whiteList: Array,
      blackList: Array,
      className: String,
      shortCodeDropdown: Boolean,
      topCountry: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: 'Select Country'
      },
      disablePlaceholder: {
        type: Boolean,
        default: false
      },
      removePlaceholder: {
        type: Boolean,
        default: false
      },
      usei18n: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return{
        ran: false,
        regionsLang : [],
        isCountry:false
      }
    },
    computed: {
      countries() {
        let countryList = this.regionsLang.filter((region) => {
          if(region.countryName==this.country){
            this.isCountry=true
          }
          if (this.countryName) {
            return region.countryName !== this.firstCountry
          } else {
            return region.countryShortCode !== this.firstCountry
          }
        })
        if (this.whiteList) {
          countryList = countryList.filter((country) => {
            return this.whiteList.includes(country.countryShortCode)
          })
        }
        if (this.blackList) {
          countryList = countryList.filter((country) => {
            return !this.blackList.includes(country.countryShortCode)
          })
        }
        if (this.$i18n && this.usei18n) {
          countryList = countryList.map((country) => {
            let localeCountry = Object.assign({ }, country)
            localeCountry.countryName = this.$t(country.countryName)
            return localeCountry
          })
          countryList.sort((country1, country2) => {
            return (country1.countryName > country2.countryName) ? 1 : -1
          })
        }

        countryList.sort((country1, country2) => {
          return country1.countryName.localeCompare(country2.countryName, "tr", {sensitivity: 'base'})
        })
        
        if (this.removePlaceholder) {
          let c = this.firstCountry || countryList[0][this.valueType]
          this.onChange(c)
        }
        return countryList
      },
      firstCountry() {
        if(this.countryName) {
          if(this.topCountry.length === 2 ) {
            const regionObj = this.regionsLang.find((region) => {
              return region.countryShortCode === this.topCountry
            })
            return regionObj.countryName
          } else {
            return this.topCountry
          }
        }
        if (this.topCountry) {
          return this.topCountry
        }
        return ''
      },
      name() {
        return this.name
      },
      value() {
        return this.country
      },
      valueType() {
        return this.countryName ? 'countryName' : 'countryShortCode'
      }
    },
    created(){
        this.$root.$moment.locale(this.$ml.current);
        if(this.$ml.current=="tr"){
          this.regionsLang=regionstr
        }else{
          this.regionsLang=regions
        }
    },
    methods: {
      onChange(country) {
        this.$emit('input', country)
        this.$emit('changeCountry', country)
      },
      topCountryName() {
        const regionObj = this.regionsLang.find((region) => {
          if (this.countryName) {
            return region.countryName === this.firstCountry
          } else {
            return region.countryShortCode === this.firstCountry
          }
        })
        if (this.$i18n && this.usei18n) {
          return this.$t(regionObj.countryName)
        }
        return this.shortCodeDropdown ? regionObj.countryShortCode : regionObj.countryName
      }
    }
  }
</script>

<template>
  <select @change="onChange($event.target.value)" :class="className">
    <option value="" v-if="!disablePlaceholder && !removePlaceholder">{{ placeholder }}</option>
    <option value="" v-else-if="disablePlaceholder && !removePlaceholder" disabled selected>{{ placeholder }}</option>
    <option :value="country" v-else-if="!isCountry && country!=''" selected>{{ country }}</option>
    <option v-if="topCountry" :value="firstCountry" :selected="country === firstCountry">{{topCountryName()}}</option>
    <option v-for="(region, index) in countries" :value="region[valueType]" :selected="country === region[valueType]" :key="index">{{ shortCodeDropdown ? region.countryShortCode : region.countryName }}</option>
  </select>
</template>
